import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import renderSelectField from '@/shared/components/form/Select';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const required = value => (value ? undefined : 'Required')

const NewMissionInstrument = (props) => {
    const history = useHistory();
    const [instruments, setInstruments] = useState();
    const [calibrations, setCalibrations] = useState();

    const getInstruments = () => {
        AdminInterface.instance.getInstruments().then((response) => {
            setInstruments(response.data)
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        });
    }

    const getCalibrations = () => {
        AdminInterface.instance.getCalibrations().then((response) => {
            setCalibrations(response.data)
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        });
    }
    
    useEffect(() => {
        if (props.location.state === undefined) return;
        getInstruments();
        getCalibrations();
    }, [props.location.state]);

    const submitNewMissionInstrument = (missionInstrument) => {
        missionInstrument.instrumentId = missionInstrument.instrumentId.value;
        missionInstrument.calibrationId = missionInstrument.calibrationId?.value;
        AdminInterface.instance.createMissionInstrument(missionInstrument).then(() => {
            withReactContent(Swal).fire({
                title: "Success",
                html: "New mission instrument is created!",
            });
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: [error.response?.data?.detail.map((detail) => detail.msg)],
            });
        });
    }

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>New Mission Instrument</CardTitle>
                </CardTitleWrap>
                {instruments && calibrations && <Form onSubmit={submitNewMissionInstrument}>
                    {({ handleSubmit, form }) => (
                        <FormContainer horizontal onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormGroupLabel>Mission Id</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="missionId" component="input" type="text" placeholder="Mission Id" initialValue={props.location.state} disabled={true} />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Instrument</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="instrumentId" component={renderSelectField} validate={required}
                                        options={instruments.map(function (instrument) {
                                            return { value: instrument.id, label: instrument.name }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Calibration (Optional)</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="calibrationId" component={renderSelectField}
                                        options={calibrations.map(function (calibration) {
                                            return { value: calibration.id, label: `${calibration.description} (${new Date(`${calibration.calibration_date}z`).toLocaleString()})` }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormButtonToolbar>
                                <Button variant="primary" type="submit">Submit</Button>
                                <Button variant="secondary" type="button" onClick={() => history.goBack()}>
                                    Back
                                </Button>
                            </FormButtonToolbar>
                        </FormContainer>
                    )}
                </Form>}
            </CardBody>
        </Card>
    );
};

export default NewMissionInstrument;